import i18next from 'i18next'
export function PriceFormater(amount: number) {
  const formattedAmount = amount?.toLocaleString(i18next.language, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
  return formattedAmount
}
